/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tramite': {
    width: 48,
    height: 48,
    viewBox: '0 0 100 100',
    data:'<path class="cls-1" d="M97.3,0H2.7A2.7,2.7,0,0,0,0,2.7V67.49c0,.06,0,.11,0,.17a2.66,2.66,0,0,0,.14.7,2.6,2.6,0,0,0,.09.26,2.67,2.67,0,0,0,.52.78h0l.13.13L30.6,99.21a2.7,2.7,0,0,0,1.91.79,2.83,2.83,0,0,0,.29-.06,2.62,2.62,0,0,0,.3.06H97.3a2.7,2.7,0,0,0,2.7-2.7V2.7A2.7,2.7,0,0,0,97.3,0ZM29.81,90.28,9.32,70.19H29.81Zm64.79,4.31H35.21V67.49a2.7,2.7,0,0,0-2.7-2.7H5.41V5.41H94.59Z"/><path class="cls-1" d="M22.58,25.68H78.22a2.7,2.7,0,1,0,0-5.41H22.58a2.7,2.7,0,0,0,0,5.41Z"/><path class="cls-1" d="M22.58,41.58H78.22a2.7,2.7,0,1,0,0-5.41H22.58a2.7,2.7,0,0,0,0,5.41Z"/><path class="cls-1" d="M78.22,52.07H46.9a2.7,2.7,0,0,0,0,5.41H78.22a2.7,2.7,0,1,0,0-5.41Z"/>',
  }
})
